import type { SVGProps } from "react";
export interface HeelsHighIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HeelsHighIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HeelsHighIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.314 15.5V20a1.125 1.125 0 0 0 2.25 0v-4.5c0-1.316.071-2.64-.466-4.339l-.04-.108a1.125 1.125 0 0 0-2.104.786l.133.474c.266 1.071.227 1.95.227 3.187"
      />
      <path
        fill={color}
        d="M.875 8c0-1.805.805-3.572 1.15-4.256l.067-.121c.34-.55.983-.839 1.625-.72l.137.03.47.148c2.299.813 3.822 2.727 5.648 5.852l.272.483c.262.483.494.96.708 1.402.292.605.541 1.13.805 1.595.536.944.983 1.362 1.516 1.496 1.214.303 2.506-.115 3.049-.338l.176-.062c.36-.103.762-.09 1.133.073l.183.094 3.99 2.395a2.721 2.721 0 0 1-1.12 5.04l-.278.014h-8.142c-.551 0-1.171-.104-1.743-.418l-.242-.146c-1.572-1.063-2.435-2.549-3.11-3.799-.722-1.337-1.187-2.283-1.945-2.888-.832-.665-1.481-1-2.506-1.292a1.13 1.13 0 0 1-.781-.799c.007.028.002 0-.123-.238-.1-.19-.245-.463-.385-.791A6.9 6.9 0 0 1 .875 8m2.25 0c0 .82.181 1.42.374 1.87.1.235.204.431.309.632l.036.073c1.052.351 1.863.805 2.785 1.542l.22.186c1.072.96 1.724 2.323 2.3 3.39.661 1.226 1.308 2.273 2.389 3.003l.134.073c.15.066.346.106.592.106h8.142l.094-.009a.47.47 0 0 0 .241-.791L20.646 18l-3.74-2.245c-.81.298-2.463.766-4.179.336-1.466-.366-2.315-1.49-2.927-2.567-.31-.546-.597-1.153-.874-1.727a25 25 0 0 0-.897-1.729c-1.712-2.93-2.862-4.214-4.24-4.783-.308.712-.664 1.749-.664 2.715"
      />
    </svg>
  );
}
